angular.module("vgresiduos").directive("hommelDiamond", function () {
	return {
		templateUrl: "views/components/hommelDiamond/hommelDiamond_template.html",
		scope: {
			diamond: "="
		}
	};
});
